/** The signing-flow step that follows connecting a bank account, skipping down payment when none is required. */
function getPostBankConnectionRoute(finalizeData) {
    return finalizeData?.downPaymentRequired ? '/down-payment' : '/autopay-auth';
}
export default getPostBankConnectionRoute;
